import { useNNEvidenceCancel } from "@/api/nn-evidence";
import {
  swalErrorDefault,
  swalLoading,
  swalSuccess,
  swalWarningDefault,
} from "@/utils/lib/swal";

export default function useCancelNnEvidence({ id }: { id: string }) {
  const { mutate: cancelNnEvidence, isPending } = useNNEvidenceCancel();

  function cancel() {
    if (id) {
      swalWarningDefault
        .fire({
          text: "Are you sure you want to cancel this NN Evidence?",
        })
        .then((result) => {
          if (result.isConfirmed) onConfirm();
        });
    }
  }

  function onConfirm() {
    swalLoading.fire();
    cancelNnEvidence(
      {
        id,
      },
      {
        onSuccess: () => {
          swalSuccess.fire({
            text: "NN Evidence has been cancelled successfully.",
          });
        },
        onError: () => {
          swalErrorDefault.fire({
            text: "Failed to cancel NN Evidence. Contact the administrator.",
          });
        },
      },
    );
  }

  return { cancel, isPending };
}
